import React, {useEffect, useState} from 'react';
// components
import {Col, Row,} from "react-bootstrap";
import VerticalMenu from '../../components/VerticalMenu'
import { useAppStore } from '../../context/state'
import { getContent } from "../../api/settings";

//style
import './style.css'

const About = (props) => {

  const { content="about", path="/editorial/about", html="" } =props;
  
  const [ loading, setLoading] = useState(true);
  const [ jsx, setJsx] = useState("" || html);
  const { commonmenu } = useAppStore.getState().settings

  useEffect(() => {
    setLoading(true);
    getContent(content)
      .then(function (response) {
        setLoading(false);
        const { data } = response
        setJsx(data.jsx)
      }).catch(function (error) {
        setLoading(false);
      })
  },[content])


  return (
    <Row>
        <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 3, order: 1 }} xl={2} style={{ minHeight:'100vh' }}>
            <VerticalMenu url={path} menu={commonmenu}/>
        </Col>
        <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 9, order: 2 }} xl={10}>
          <div dangerouslySetInnerHTML={{__html: jsx}}></div>
        </Col>
    </Row>
  );
};

export default About;


